import karteCustonEventClient from '../common/karte/custom_event';

document.addEventListener('DOMContentLoaded', () => {
  const bulkIndexDiv = document.getElementById('leaflet_bulk_imports_index') as HTMLElement;
  if (bulkIndexDiv == null) {
    return;
  }

  const SHOW_PARTIAL_DISPLAY = 15;

  const handleClickToggleButton = (button: Element) => {
    const rowId = button.getAttribute('data-row-id');

    button.addEventListener('click', () => {
      const storeBadge = bulkIndexDiv.querySelector('[data-row-id="' + rowId + '"]')
      if (button.classList.contains('expand-button')) {
        storeBadge?.classList.remove('partial-display');
        button.classList.add('hidden');
        button.nextElementSibling?.classList.remove('hidden');
      } else {
        storeBadge?.classList.add('partial-display');
        button.classList.add('hidden');
        button.previousElementSibling?.classList.remove('hidden');
      }
    });
  }

  const addEventForButtons = () => {
    const expandButtons = bulkIndexDiv.querySelectorAll('.expand-button');
    const contractButtons = bulkIndexDiv.querySelectorAll('.contract-button');

    expandButtons.forEach(button => {
      handleClickToggleButton(button);
    });
    contractButtons.forEach(button => {
      handleClickToggleButton(button);
    });
  }

  const settingStoreGroupBadges = () => {
    const storeGroupBadgeDivs = bulkIndexDiv.querySelectorAll('.store-group-badges-for-bulk-import');
    storeGroupBadgeDivs.forEach(storeGroupBadgeDiv => {
      const storeGroupBadges = storeGroupBadgeDiv.querySelectorAll('.badge');
      const storeGroupBadgesArea = storeGroupBadgeDiv.querySelector('.store-group-badges') as HTMLElement;

      if (SHOW_PARTIAL_DISPLAY < storeGroupBadges.length) {
        storeGroupBadgesArea.classList.add('partial-display');

        // 全ての店舗を表示するボタンを表示する
        const expandButton = storeGroupBadgeDiv.querySelector('.expand-button') as HTMLElement
        expandButton.classList.remove('hidden');
      }
    });
  }

  // 登録時に実行
  bulkIndexDiv.addEventListener('submit', () => {
    // KARTEに登録イベントを送信
    sendKarteEvent(
      'create_content',
      'leaflet_bulk_imports',
      'チラシ投稿グループを新規で登録しました'
    );
  })

  const sendKarteEvent = (event_name: string, content_name: string, message: string) => {
    // 投稿したことをKARTEに通知
    karteCustonEventClient.sendEvent({
      event_name: event_name,
      content_name: content_name,
      message: message
    });
  }

  const initialize = () => {
    settingStoreGroupBadges();
    addEventForButtons();
  }

  // 初期化
  initialize();
});
